module.exports = __webpack_public_path__ + "static/media/placeholder_bar.df017aa9.png";